<template>
  <v-card class="card-border">
    <highcharts :options="chartOptions" />
  </v-card>
</template>

<script>
import { Chart } from "highcharts-vue";
import { mapGetters } from "vuex";

export default {
  name: "HistoricoRanks",

  components: {
    highcharts: Chart
  },

  data() {
    return {
      chartOptions: {
        chart: {
          zoomType: "x"
        },
        title: {
          text: "Historico de Leads x Vendas"
        },
        subtitle: {
          text: "Ultimos 6(seis) Meses"
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: function(date) {
              const dateFormatted = new Date(date.value);
              const month = dateFormatted.toLocaleString("default", {
                month: "long"
              });
              return `${month}/${dateFormatted.getFullYear()}`;
            }
          }
        },
        yAxis: {
          title: {
            text: "Quantidade"
          }
        },
        legend: {
          enabled: true
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true
            },
            tooltip: {
              xDateFormat: "%m/%Y",
              pointFormat: "{series.name}: <b>{point.y}</b>"
            },
            enableMouseTracking: true
          }
        },
        series: [
          {
            type: "line",
            name: "Leads",
            data: []
          },
          {
            type: "line",
            name: "Consorcio",
            data: []
          },
          {
            type: "line",
            name: "Novos",
            data: []
          },
          {
            type: "line",
            name: "Usados",
            data: []
          }
        ]
      }
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getHistoricoRank"])
  },

  methods: {
    clearGrafic() {
      this.chartOptions.series[0].data = [];
      this.chartOptions.series[1].data = [];
      this.chartOptions.series[2].data = [];
      this.chartOptions.series[3].data = [];
    },

    generateGrafic(historicoRank) {
      const historico = [];
      for (let i = 0; i < historicoRank.length; i++) {
        let date = new Date(
          historicoRank[i].dataUltimaAtualizacao.seconds * 1000
        );
        date.setHours(13, 0, 0, 0);
        date.setMonth(date.getMonth() + 1, 0);
        if (historico[date] === undefined) {
          historico[date] = {};
          historico[date].leads = historicoRank[i].leads;
          historico[date].consorcio = historicoRank[i].consorcio;
          historico[date].novos = historicoRank[i].novos;
          historico[date].usados = historicoRank[i].usados;
        } else {
          historico[date].leads += historicoRank[i].leads;
          historico[date].consorcio += historicoRank[i].consorcio;
          historico[date].novos += historicoRank[i].novos;
          historico[date].usados += historicoRank[i].usados;
        }
      }

      for (const date in historico) {
        const rank = historico[date];
        const dateRank = new Date(date).getTime();
        this.chartOptions.series[0].data.push([dateRank, rank.leads]);
        this.chartOptions.series[1].data.push([dateRank, rank.consorcio]);
        this.chartOptions.series[2].data.push([dateRank, rank.novos]);
        this.chartOptions.series[3].data.push([dateRank, rank.usados]);
      }
    }
  },

  watch: {
    getHistoricoRank(historicoRank) {
      this.clearGrafic();
      this.generateGrafic(historicoRank);
    }
  },

  mounted() {
    if (this.getHistoricoRank.length !== 0) {
      this.clearGrafic();
      this.generateGrafic(this.getHistoricoRank);
    }
  }
};
</script>
